import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { Home } from "./pages/Home.js";
import { AnnouncementsList } from "./pages/AnnouncementsList.js";
import { AnnouncementForm } from "./pages/AnnouncementForm.js";
import { PushList } from "./pages/PushList.js";
import { PushForm } from "./pages/PushForm.js";
import { InboundList } from "./pages/InboundList.js";
import { InboundDetail } from "./pages/InboundDetail.js";
import { LoginPage } from "./pages/Login.js";
import { AuthProvider, RequireAuth, useAuth } from "./auth.js";

function HeaderUser() {
  const { email, logout } = useAuth();
  const navigate = useNavigate();
  if (!email) return null;
  return (
    <span style={{ marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" }}>
      <span data-testid="auth-email" style={{ color: "var(--muted)" }}>{email}</span>
      <button
        type="button"
        className="btn secondary"
        onClick={async () => {
          await logout();
          navigate("/login");
        }}
        data-testid="logout-btn"
      >
        ログアウト
      </button>
    </span>
  );
}

export function App() {
  return (
    <AuthProvider>
      <header className="app-header">
        <strong>m50 messaging</strong>
        <nav>
          <Link to="/">home</Link>
          <Link to="/announcements">お知らせ</Link>
          <Link to="/push">push</Link>
          <Link to="/inbound">inbound</Link>
        </nav>
        <HeaderUser />
      </header>
      <main className="content">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
          <Route path="/announcements" element={<RequireAuth><AnnouncementsList /></RequireAuth>} />
          <Route path="/announcements/new" element={<RequireAuth><AnnouncementForm mode="create" /></RequireAuth>} />
          <Route path="/announcements/:id" element={<RequireAuth><AnnouncementForm mode="edit" /></RequireAuth>} />
          <Route path="/push" element={<RequireAuth><PushList /></RequireAuth>} />
          <Route path="/push/new" element={<RequireAuth><PushForm mode="create" /></RequireAuth>} />
          <Route path="/push/:id" element={<RequireAuth><PushForm mode="edit" /></RequireAuth>} />
          <Route path="/inbound" element={<RequireAuth><InboundList /></RequireAuth>} />
          <Route path="/inbound/:id" element={<RequireAuth><InboundDetail /></RequireAuth>} />
        </Routes>
      </main>
    </AuthProvider>
  );
}
